module.exports = __webpack_public_path__ + "static/media/32-13.134b2dc2.mp3";